import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { ENVIRONMENT, Environment } from '@netfoundry-ui/shared/model';
import { NF_VALIDATE_HEADER } from '@netfoundry-ui/shared/services';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FrontdoorExecutionActivityService } from './frontdoor-execution-activity.service';

/** Reads are not writes, so they start no process. */
const READ_METHODS = ['GET', 'HEAD', 'OPTIONS'];

/**
 * Asks {@link FrontdoorExecutionActivityService} for a fresh answer after each successful write to the
 * frontdoor v3 API, because a write can start a process. Dry runs and execution calls are skipped.
 */
@Injectable()
export class FrontdoorExecutionActivityInterceptor implements HttpInterceptor {
    private readonly v3Prefix: string;

    constructor(@Inject(ENVIRONMENT) environment: Environment, private injector: Injector) {
        this.v3Prefix = environment.frontdoorURL ? `${environment.frontdoorURL}/v3/` : '';
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!this.startsProcess(request)) {
            return next.handle(request);
        }
        return next.handle(request).pipe(
            tap((event) => {
                if (event instanceof HttpResponse && event.ok) {
                    this.activity().refresh();
                }
            })
        );
    }

    private startsProcess(request: HttpRequest<unknown>): boolean {
        return (
            !!this.v3Prefix &&
            request.url.startsWith(this.v3Prefix) &&
            !READ_METHODS.includes(request.method) &&
            !request.headers.has(NF_VALIDATE_HEADER) &&
            !request.url.includes('/executions')
        );
    }

    /** Resolved on use, because the service needs HttpClient, and HttpClient builds this interceptor. */
    private activity(): FrontdoorExecutionActivityService {
        return this.injector.get(FrontdoorExecutionActivityService);
    }
}
